import { MembershipsCreatorApiClient } from '@fourthwall/services/dist/MembershipsCreatorApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useDeleteFreeTierMutation = createMutationHook(
  MembershipsCreatorApiClient.deleteFreeTier,
  {
    mutationKey: ['deleteFreeTier'],
  },
)
